import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('dealers', options)



// WEBPACK FOOTER //
// ./src/store/modules/dealers.store.js